import React, { Component } from 'react'
import './users.css'
import { Link } from 'react-router-dom'
import _ from 'lodash'
import getLabel from '../../utilities/label.js'
import AvatarEditor from 'react-avatar-editor'

export default class MyProfilePhoto extends Component {

  constructor(props) {
    super(props)
    this.user = this.getUser(window.currentUser.user_id)
    this.state = this.originalState()
    this.props.setActiveTab('homepage')
    this.handleNewImage = this.handleNewImage.bind(this)
    this.handleCrop = this.handleCrop.bind(this)
    this.handleScale = this.handleScale.bind(this)
    this.rotateLeft = this.rotateLeft.bind(this)
    this.rotateRight = this.rotateRight.bind(this)
    this.setEditorRef = this.setEditorRef.bind(this)
    this.handlePositionChange = this.handlePositionChange.bind(this)
    this.handleDrop = this.handleDrop.bind(this)
    window.trackPage('ProfileEditPhotoFormScreen')
  }

  resetOriginalState() {
    this.setState(this.originalState())
  }

  originalState() {
    return {
      user: this.user,
      image: null,
      allowZoomOut: false,
      position: { x: 0.5, y: 0.5 },
      scale: 1,
      rotate: 0,
      borderRadius: 0,
      width: 300,
      height: 300,
      preview: null
    }
  }

  getUser(id) {
    return _.find(this.props.users.event_users, {user_id: parseInt(id, 10)})
  }

  handleNewImage(e) {
    if(e.target.files[0]) {
      var fileType = e.target.files[0]['type']
      var ValidImageTypes = ['image/jpeg', 'image/png']
      if (_.indexOf(ValidImageTypes, fileType) < 0) {
        this.props.flashMessage({
          message: 'Profile image must be in .jpg, .jpeg, or .png format',
          type: 'error'
        })
        return false
      }
    }
    this.setState({ image: e.target.files[0] })
  }

  handleCrop() {
    const img = this.editor.getImageScaledToCanvas().toDataURL()
    const rect = this.editor.getCroppingRect()

    this.setState({
      preview: {
        img,
        rect,
        scale: this.state.scale,
        width: this.state.width,
        height: this.state.height,
        borderRadius: this.state.borderRadius,
      },
    })
  }

  handleScale(e) {
    const scale = parseFloat(e.target.value)
    this.setState({ scale })
  }

  rotateLeft(e) {
    e.preventDefault()

    this.setState({
      rotate: this.state.rotate - 90,
    })
  }

  rotateRight(e) {
    e.preventDefault()
    this.setState({
      rotate: this.state.rotate + 90,
    })
  }

  logCallback() {
    // eslint-disable-next-line
    // console.log('callback', e)
  }

  setEditorRef(editor) {
    if (editor) this.editor = editor
  }

  handlePositionChange(position) {
    this.setState({ position })
  }

  handleDrop(acceptedFiles) {
    this.setState({ image: acceptedFiles[0] })
  }

  saveBlob() {
    let canvas = this.editor.getImageScaledToCanvas()
    return new Promise((resolve) => {
      return canvas.toBlob(file => {
        file.name = 'x.jpeg'
        file.lastModifiedDate = new Date()
        resolve(file)
      }, 'image/jpeg')
    })
  }

  cancel() {
    window.location.href = '/my_profile'
  }

  saveImage(e) {
    this.handleCrop()
    e.currentTarget.disabled = true
    this.saveBlob().then(blob =>
    {
      const form = document.createElement('form')
      const fd = new FormData(form)
      fd.append('file', blob)
      this.props.postResource({key: 'post_photo', data: fd, callback: (response) => {
        let user = this.state.user
        user.photo = response.data.url
        this.setState({
          user: user
        })
        this.props.flashMessage({message: getLabel('photo_save_success')})
        this.resetOriginalState()
        this.props.history.push('/my_profile')
      }})
    })
  }

  render() {
    return (
      <div className="my-profile-photo">
        {!this.state.preview && !this.state.image && (
          <div>
            <p><img className="rounded-circle" alt="user" src={this.state.user.photo} /></p>
            <div>
              <Link to="my_profile"><button className="btn btn-danger" >{getLabel('cancel')}</button></Link>
              <label className="custom-file-upload">
                <input name="newImage" type="file" onChange={this.handleNewImage} />
                {getLabel('upload_photo')}&nbsp;&nbsp;<i className="fa fa-plus"></i>
              </label>
              <p>{getLabel('jpeg_or_png_only')}</p>
            </div>
          </div>
        )
        }
        {this.state.image &&
          <div>
          	<br />
          	<br />
          	<AvatarEditor
          		ref={this.setEditorRef}
          		scale={parseFloat(this.state.scale)}
          		width={this.state.width}
          		height={this.state.height}
          		position={this.state.position}
          		onPositionChange={this.handlePositionChange}
          		rotate={parseFloat(this.state.rotate)}
          		borderRadius={this.state.width / (100 / this.state.borderRadius)}
          		onLoadFailure={this.logCallback.bind(this, 'onLoadFailed')}
          		onLoadSuccess={this.logCallback.bind(this, 'onLoadSuccess')}
          		onImageReady={this.logCallback.bind(this, 'onImageReady')}
          		image={this.state.image}
          		className="editor-canvas"
          	/>

          	<p>{getLabel('zoom')}:</p>
          	<p>
          		<input
          			name="scale"
          			type="range"
          			onChange={this.handleScale}
          			min={this.state.allowZoomOut ? '0.1' : '1'}
          			max="2"
          			step="0.01"
          			defaultValue="1"
          		/></p>

          	<p>
          		<Link to="my_profile"><button className="btn btn-danger" >{getLabel('cancel')}</button></Link>
          		<button
                className="btn btn-primary"
                onClick={this.rotateLeft}>
                { getLabel('rotate') }
                &nbsp;&nbsp;
                <i className="fa fa-repeat"></i>
              </button>
          		<button className="btn btn-primary" onClick={this.saveImage.bind(this)}>{getLabel('save')}</button>
          	</p>
          </div>
        }
      </div>
    )
  }
}
